import { useMutation } from '@tanstack/react-query'
import { useAPI } from '../../../Contexts/APIContext'

export const useCreateTease = () => {
  const { createTease } = useAPI()

  return useMutation({
    mutationFn: data =>
      createTease({
        ...data,
      }),
  })
}
